import { Button, Avatar } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export default function SidebarUser(user) {
  const navigate = useNavigate();
  // const user = JSON.parse(localStorage.getItem("user"));

  const handleLogout = () => {
    // 1️⃣ 清空本地数据
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    // 2️⃣ 跳转登录页
    navigate("/login", { replace: true });
  };

  if (!user) return null;

  return (
    <div style={{ padding: 16, borderBottom: "1px solid #eee" }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
        <Avatar icon={<UserOutlined />} />
        <div style={{ marginLeft: 8 }}>
          <div style={{ fontSize: 12, color: "#f0eeeeff" }}>
            {user.name || user.username}
          </div>
          <div style={{ fontSize: 12, color: "#f0eeeeff" }}>
            {user.role === "admin" ? "系统管理员" : "普通用户"}
          </div>
        </div>
      </div>

      <Button
        icon={<LogoutOutlined />}
        size="small"
        danger
        block
        onClick={handleLogout}
      >
        退出登录
      </Button>
    </div>
  );
}
